import { FormPagePropertyItem } from 'backend';
import { PROPERTY_TYPE } from 'shared';
import { PropertyItemElement } from '..';
import { getDatePropertyItemElementFormCustomize } from './date';
import { getMailddressPropertyItemElementFormCustomize } from './mailAddress';
import { getMailRefusalFlagPropertyItemElementFormCustomize } from './mailRefusalFlag';
import { getMonthDayPropertyItemElementFormCustomize } from './monthDay';
import { getMultipleSelectionPropertyItemElementFormCustomize } from './multipleSelection';
import { getNumberPropertyItemElementFormCustomize } from './number';
import { getPasswordHashPropertyItemElementFormCustomize } from './passwordHash';
import { getSingleSelectionPropertyItemElementFormCustomize } from './singleSelection';
import { getTextPropertyItemElementFormCustomize } from './text';

export const getPropertyItemElementFormCustomize = (
  propertyItem: FormPagePropertyItem,
): PropertyItemElement => {
  switch (propertyItem.propertyType) {
    case PROPERTY_TYPE.mailAddress: {
      return getMailddressPropertyItemElementFormCustomize(propertyItem);
    }
    case PROPERTY_TYPE.text: {
      return getTextPropertyItemElementFormCustomize(propertyItem);
    }
    case PROPERTY_TYPE.number: {
      return getNumberPropertyItemElementFormCustomize(propertyItem);
    }
    case PROPERTY_TYPE.date: {
      return getDatePropertyItemElementFormCustomize(propertyItem);
    }
    case PROPERTY_TYPE.monthDay: {
      return getMonthDayPropertyItemElementFormCustomize(propertyItem);
    }
    case PROPERTY_TYPE.singleSelection: {
      return getSingleSelectionPropertyItemElementFormCustomize(propertyItem);
    }
    case PROPERTY_TYPE.multipleSelection: {
      return getMultipleSelectionPropertyItemElementFormCustomize(propertyItem);
    }
    case PROPERTY_TYPE.passwordHash: {
      return getPasswordHashPropertyItemElementFormCustomize(propertyItem);
    }
    case PROPERTY_TYPE.mailRefusalFlag: {
      return getMailRefusalFlagPropertyItemElementFormCustomize(propertyItem);
    }
    default: {
      return {};
    }
  }
};
